// extracted by mini-css-extract-plugin
module.exports = {"header":"i_Ao","body":"i_Ap","image":"i_Aq","form-group":"i_Ar"};